import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const ClientDetailsContainer = styled.div`
  width: 100%;
  margin-bottom: 2em;
`;

export const ClientDetailsRow = styled.div`
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) max-content;
  column-gap: 1.5em;
  align-items: center;
  padding: 0.2em 1.75em;
  position: relative;

  &:first-child::before {
    content: "";
    position: absolute;
    left: 1em;
    right: 0;
    top: 0;
    height: 1px;
    background: ${colours.elexonBlue};
  }

  &::after {
    content: "";
    position: absolute;
    left: 1em;
    right: 0;
    bottom: 0;
    height: 1px;
    background: ${colours.elexonBlue};
  }

  > :last-child {
    justify-self: end;
    align-self: center;
    display: flex;
    align-items: center;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    row-gap: 0.5em;

    > :last-child {
      justify-self: start;
    }
  }
`;

export const Label = styled.span`
  font-weight: ${fontWeights.bold};
  color: ${colours.elexonBlack};
`;

export const Value = styled.span`
  color: ${colours.darkGrey};
  word-break: break-word;
`;
